// Small pieces of the report hierarchy rows: what a row covers, and the state of a level that loads when it opens.
import { useContext } from "react";
import { Context } from "../../context/Context";
import { Button } from "../ui";
import { getReportText } from "./reportText";

// state: { loading, error, onRetry }. Renders nothing once the level is there.
export const NodeState = ({ state }) => {
  const { lang } = useContext(Context);
  const text = getReportText(lang);
  if (state.loading) {
    return (
      <p className="report-state" role="status">
        {text.rowsLoading}
      </p>
    );
  }
  if (!state.error) return null;
  return (
    <div className="report-state" role="alert">
      <p>{text.loadFailed}</p>
      <Button size="sm" variant="primary" appearance="soft" onClick={state.onRetry}>
        {text.retry}
      </Button>
    </div>
  );
};
